import { Container, Spinner } from '@chakra-ui/react';
import axios, { isAxiosError } from 'axios';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { defaultSpinnerProps } from 'components/AsyncWrapper';
import useUserContext from 'hooks/useUserContext';

export default function ProcessPlanBasedSubscription(): JSX.Element {
  const { refreshUser } = useUserContext();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('sessionId');
  const navigate = useNavigate();

  const isCheckoutSessionProcessed = useRef<boolean>(false);

  useEffect(() => {
    const finalizeSubscription = async (): Promise<void> => {
      if (!isCheckoutSessionProcessed.current && sessionId) {
        try {
          isCheckoutSessionProcessed.current = true;
          await axios.post('/api/billing/subscription/process-subscription-callback', { sessionId });

          await refreshUser();
          navigate('/settings/billing');
        } catch (error) {
          isCheckoutSessionProcessed.current = false;
          throw new Error(isAxiosError(error)
            ? (error.response?.data as { message?: string })?.message || 'Unknown error'
            : String(error));
        }
      }
    };

    void finalizeSubscription();
  }, [sessionId, navigate, refreshUser]);

  return (
    <Container centerContent>
      <Spinner {...defaultSpinnerProps} />
    </Container>
  );
}
